import { ROUTES } from '@/config/routes'
import { $api } from './axios'
import { LoginTGBody, LoginTGResponse, RegisterTGBody, RegisterTGResponse } from './types'
import { AxiosError, AxiosResponse } from 'axios'
import { AxiosError as Error } from './types'

export class AuthApi {
    static async LoginTG(payload: LoginTGBody): Promise<LoginTGResponse> {
        try {
            const { data } = await $api.post<LoginTGBody, AxiosResponse<LoginTGResponse>>(ROUTES.auth.login_tg, JSON.stringify(payload))
            return data
        } catch (error) {
            if (error instanceof AxiosError && error.response?.status === 401) {
                // Типизированная обработка 401
                const authError = error.response.data as Error
                throw authError
            }

            throw error
        }
    }

    static async RegisterTG(payload: RegisterTGBody): Promise<RegisterTGResponse> {
        try {
            const { data } = await $api.post<RegisterTGBody, AxiosResponse<RegisterTGResponse>>(ROUTES.auth.register_tg, JSON.stringify(payload))
            return data
        } catch (error) {
            if (error instanceof AxiosError && error.response?.status === 401) {
                // Типизированная обработка 401
                const authError = error.response.data as Error
                throw authError
            }
            throw error
        }
    }
}
